import { render, staticRenderFns } from "./FamilyHistoryForm.vue?vue&type=template&id=ef4902b4&scoped=true&"
import script from "./FamilyHistoryForm.vue?vue&type=script&lang=js&"
export * from "./FamilyHistoryForm.vue?vue&type=script&lang=js&"
import style0 from "./FamilyHistoryForm.vue?vue&type=style&index=0&id=ef4902b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef4902b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VRow,VTextField})
